<template>
  <section class="policy-form">
    <lazy-dom>
      <el-form
        ref="form"
        :rules="rules"
        :model="resultForm">
        <div class="flex flex-align-center">
          <div class="form-item form-half">
            <span>Effective Date</span>
            <el-form-item
              ref="pcy_cmnt_dt"
              prop="pcy_cmnt_dt">
              <v-date-picker
                v-if="!isAdjust"
                v-model="resultForm.pcy_cmnt_dt" />
              <v-datetime-picker
                v-else
                v-model="resultForm.pcy_cmnt_dt"
                @change="handlerChangePcyDt" />
            </el-form-item>
          </div>
          <template v-if="isAdjust">
            <span class="mg-l-15 mg-r-15 color-dark fs-14">Or</span>
            <v-checkbox
              v-model="formData.is_eff_dt_delay"
              :is-boolean="false"
              button-type>As Soon As Possible</v-checkbox>
          </template>
        </div>
        <div class="form-item form-half">
          <span>Cover Note Effective Days</span>
          <el-form-item
            ref="pcy_cmnt_dt"
            prop="pcy_cmnt_dt">
            <v-select
              v-model="resultForm.cvr_nt_isrd_days"
              :list="cvr_nt_isrd_days"
              @change="handleChangeCvrDays"
            />
          </el-form-item>
        </div>
      </el-form>

      <div class="form-item form-half">
        <span>Cover Note Expiry Date</span>
        <v-date-picker
          v-model="resultForm.cvr_nt_expry_dt "
          disabled />
      </div>
      <div
        v-if="!isMotorTrade&&!isHzmb"
        class="form-item form-half">
        <span>Coverage</span>
        <v-radio-group
          v-model="resultForm.trm_of_cvr"
          disabled
          :button="true"
          :list="allCoverTypeOptions" />
      </div>
      <template v-if="isMotorTrade&&!isHzmb">
        <div class="form-item">
          <span>Type of insurance</span>
          <v-radio-group
            v-model="resultForm.type_of_ins"
            :button="true"
            disabled
            :list="allOptions13.type_of_ins" />
        </div>
        <div
          v-if="resultForm.type_of_ins == 2"
          class="form-item">
          <span>Number of Named Driver(s)</span>
          <v-radio-group
            v-model="resultForm.no_of_nm_drvr"
            :button="true"
            disabled
            :list="numberFourOptions"
          />
        </div>
        <div class="form-item">
          <span>No Claims in the past 3 years?</span>
          <v-radio-group
            v-model="resultForm.no_claim_3_year"
            :border="true"
            :list="yesNoOptions"
          />
        </div>
      </template>
      <template v-if="resultForm.class_id !== 14&&!isMotorTrade">
        <div class="flex-sb">
          <div class="form-half">
            <div
              v-if="resultForm.trm_of_cvr != 1||isHzmb"
              class="form-item">
              <span>Hire Purchase Owner</span>
              <!--              <el-form-item prop="hp_ind">-->
              <v-radio-group
                v-model="resultForm.hp_ind"
                :border="true"
                :list="yesNoOptions"/>
              <!--              </el-form-item>-->
            </div>
          </div>
          <div class="form-half">
            <div
              v-if="resultForm.trm_of_cvr != 1&&!isHzmb"
              class="form-item">
              <span>Vehicle Market Value (Sum Insured)</span>
              <!--              <el-form-item prop="isrd_vl">-->
              <v-input
                v-model="resultForm.isrd_vl"
                type="number"
                :min="0"
                append="HK$"/>
              <!--              </el-form-item>-->
            </div>
            <div
              v-if="(resultForm.trm_of_cvr != 1||isHzmb) && resultForm.hp_ind == 1"
              class="form-item">
              <span>Name of Hire Purchase Owner</span>
              <!--              <el-form-item prop="mortgagor">-->
              <v-select
                v-model="resultForm.mortgagor"
                :list="mortgagorOption"/>
              <!--              </el-form-item>-->
              <div
                v-if="isMortgagorOther"
                ref="mortgagor_other"
                class="margin-top-ten"
                prop="mortgagor_other">
                <v-input
                  v-model="resultForm.mortgagor_other"
                />
              </div>
            </div>
          </div>
        </div>
      </template>
      <!--      <h2>Insured Vehicle</h2>-->
      <div
        v-if="benefitList.length>0"
        class="box">
        <div
          class="form-item form-half extra-box">
          <span>Insured Items</span>
          <v-checkbox-group
            v-model="resultForm.benefits"
            :list="benefitList"
          />
        </div>
      </div>
      <div
        v-if="resultForm.class_id == 11 && extrabenefitsList.length>0"
        class="form-item form-half extra-box">
        <span>Extra Benefits</span>
        <v-checkbox-group
          v-model="resultForm.extra_benefits"
          :button="true"
          :list="extrabenefitsList"
        />
      </div>
      <template v-if="!isMotorTrade">
        <insured-vehicle-form
          ref="insured-vehicle-form"
          :formDataLock="formDataLock"
          :form="formData"
          :usageInd.sync="formData.usage_ind"
          @getFormData="getSubFormData"
          @handleModel="handleModel"
          @handleInd="handleInd"
          @already-owned="handleOwned"
        />
      </template>
      <h2>Policyholder Details</h2>
      <policy-holder-form
        ref="policy-holder-form"
        :formDataLock="formDataLock"
        :form="formData"
        :usage-ind="formData.usage_ind"
        :is-t-plate="isTPlate"
        @one-driver="(status) => policyOneDriver = status"
        @change-driver="handlerPolicyDriverInfo"
        @getFormData="getSubFormData"
        @confirm="handlerConfirmChangeInfo"
      />
      <template v-if="isMotorTrade&&!isTPlate||!isMotorTrade">
        <h2>Named Driver Information</h2>
        <drivers-base-info-form
          ref="drivers-base-info-form"
          :formDataLock="formDataLock"
          :form="formData"
          :usage-ind="formData.usage_ind"
          :orderId="orderId"
          :policyOneDriver="policyOneDriver"
          @changeOpenStatus="changeDriversOpenStatus"
          @upload-file="uploadDriversFile"
          @getFormData="getSubFormData"
          @change-policy-file="handlerDriverPolicyFile"
          @open-driver="handlerOpenDriver" />
      </template>
      <h2>Documents</h2>
      <document-form
        ref="document-form"
        :formDataLock="formDataLock"
        :form="formData"
        :currentDriversData="currentDriversData"
        @upload-file="handlerUploadCardFile"
        @delete-card-file="handlerDeleteCardFile" />
    </lazy-dom>
  </section>
</template>
<script>
import InsuredVehicleForm from '@/views/components/insured-vehicle-form'
import PolicyHolderForm from '@/views/components/policy-holder-form'
import DriversBaseInfoForm from '@/views/components/drivers-base-info-form'
import DocumentForm from '@/views/tickets/components/document-form'
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
import dayjs from 'dayjs'

export default {
  name: 'PolicyForm',
  components: {
    InsuredVehicleForm,
    PolicyHolderForm,
    DriversBaseInfoForm,
    DocumentForm
  },
  mixins: [MixinOptions, MixinRules],
  props: {
    // orderId: [String, Number],
    form: {
      type: Object,
      default: () => ({})
    },
    isAdjust:{
      type: Boolean,
      default: false
    },
    usageInd: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      formDataLock: 0, // 表單鎖，防止外層修改數據覆蓋了組件裏的表單數據
      formData: {
        usage_ind:'',
      },
      resultForm: {
        updDefInfo: [],
        pcy_cmnt_dt: '',
        cvr_nt_expry_dt: '',
        cvr_nt_isrd_days : '',
        benefits:[],
        extra_benefits:[],
        no_claim_3_year:'',
        no_of_nm_drvr:'',
        type_of_ins:''
      },
      policyOneDriver: false, // 投保人關聯第一名記名司機
      subForm: {
        'insured-vehicle-form': false,
        'policy-holder-form': false,
        'drivers-base-info-form': false,
        // 'document-form': false
      },
      currentDriversData: []
    }
  },
  computed: {
    isFina(){
      let {merchant_platform} = this.form||{}
      return merchant_platform ==2
    },
    extrabenefitsList() {
      let benefits = this.localAllOptions.extra_benefits || []
      // benefits = benefits.filter(item=>item.is_enabled==1)
      if(this.isFina) return  []
      return benefits||[]
    },
    benefitList(){
      let {quote_coverage_list} =this.form||{}
      let {kyc_benefit=[]} = quote_coverage_list||{}
      let arr = []
      kyc_benefit.some(item=>{
        if(item.is_show!==0){
          arr.push({name:item.name,id:item.id})
        }
      })
      return arr||[]
    },
    orderId() {
      return this.form.id
    },
    classId() {
      return this.form.class_id || 14
    },
    isHzmb(){
      return this.classId == 15
    },
    localAllOptions() {
      if (this.classId === 14) {
        return this.allOptions
      } else {
        return this[`allOptions${this.classId}`] || { mortgagor: [] }
      }
    },
    mortgagorOption() {
      // 拿status 為1的數據
      let { mortgagor=[] } = this.localAllOptions
      if(mortgagor.length) {
        mortgagor = mortgagor.filter(e=>e.status)
      }
      return mortgagor
    },
    isMortgagorOther(){
      let {mortgagor}=this.form
      let list = this.mortgagorOption.filter(item=>{
        return item.id==mortgagor
      })
      return list.length>0&&list[0].is_other==1?true:false
    },
    isMotorTrade(){
      let {class_id} = this.form||{}
      return class_id ==13
    },
    isTPlate(){
      let {type_of_ins} = this.form||{}
      return type_of_ins ==1
    }
  },
  watch: {
    form: {
      immediate: true,
      deep: true,
      handler(val) {
        let {quote_coverage_list} = val||{}
        let {kyc_benefit=[]} = quote_coverage_list||{}
        this.formData.benefits = []
        kyc_benefit.some(item=>{
          if(item.is_selected==1)
          {
            this.formData.benefits.push(item.id)
          }
        })
        let params = Object.assign(this.formData, val)
        params.benefits= [...new Set( params.benefits)]
        this.formDataLock += 1
        this.formData = JSON.parse(JSON.stringify(params))
        this.resultForm = JSON.parse(JSON.stringify(params))
        let {class_id} = this.formData||{}
        if(class_id==11){
          this.handlerExtraData()
        }
      }
    },
  },
  methods: {
    handleChangeCvrDays(){
      let {pcy_cmnt_dt,cvr_nt_isrd_days} = this.resultForm||{}
      let day = dayjs(pcy_cmnt_dt).add(cvr_nt_isrd_days,'day').format('YYYY-MM-DD 23:59:59')
      this.resultForm.cvr_nt_expry_dt = day
    },
    handlerChangePcyDt(){
      this.formData.is_eff_dt_delay = 0
    },
    changeInsurance(){
      this.handlerExtraData()
    },
    handlerExtraData(){
      let {class_id,model_id, nm_drvr_list, enough_age_ind,enough_exp_ind} = this.quoteForm||{}
      if(class_id==11)
      {
        let {trm_of_cvr = []} = this.filterData||{}
        this.updateExtraOptions({trm_of_cvr,class_id,model_id,nm_drvr_list,enough_age_ind,enough_exp_ind})
      }
    },
    handleModel(model_id){
      let {class_id, nm_drvr_list, enough_age_ind,enough_exp_ind} = this.quoteForm||{}
      if(class_id==11)
      {
        let {trm_of_cvr = []} = this.filterData||{}
        this.updateExtraOptions({trm_of_cvr,class_id,model_id,nm_drvr_list,enough_age_ind,enough_exp_ind})
      }
    },
    handleInd(params){
      Object.assign(this.formData,params)
      let obj = JSON.parse(JSON.stringify(this.formData))
      this.formData = obj
    },
    handleOwned(params){
      this.formData.already_owned_by_ind = params
    },
    getSubFormData(form, data) {
      this.subForm[form] = true
      this.resultForm = Object.assign(this.resultForm, data)
    },
    // 投保人資料關聯幾名司機
    handlerPolicyDriverInfo(data) {
      const id_type_pic = this.$refs['document-form'].getCardFileData()
      const result = {
        ...data,
        id_type_pic
      }
      this.$refs['drivers-base-info-form'].handlerPolicyDriverInfo(result)
    },
    handlerUploadCardFile(data) {
      if(this.policyOneDriver) {
        this.$refs['drivers-base-info-form'].updateOnePolicyFile(data)
      }
    },
    handlerDeleteCardFile() {
      if(this.policyOneDriver) {
        this.$refs['drivers-base-info-form'].deleteOnePolicyFile()
      }
    },
    changeDriversOpenStatus(index, status) {
    //   this.nm_drvr_list_file[index].open = status
    },
    handlerDriverPolicyFile(data) {
      this.$refs['document-form'].updatePolicyFile(data)
    },
    // 更新司機文件數據
    uploadDriversFile(data) {
      this.$refs['document-form'].updateDriversFile(data)
    },
    handlerConfirmChangeInfo(result) {
      if(result) {
        this.resultForm.upd_def_addr = 1
      }
      // 傳遞數據
      this.$emit('submit', this.resultForm)
    },
    async submitForm() {
      // Object.keys(this.subForm).some(key => {
      //   this.subForm[key] = false
      //   this.$refs[key].submitForm(key)
      // })
      // if (Object.values(this.subForm).some(item => item === false)) {
      //   return
      // }
      if(!this.handler().validateForm()) {
        return
      }
      const documentParams = await this.$refs['document-form'].submitForm()
      if(!documentParams) return

      // const params = JSON.parse(JSON.stringify(this.resultForm))
      // Object.assign(params, documentParams)
      // return params
      this.resultForm = Object.assign(this.resultForm, documentParams)

      this.$refs.form.validate((valid, rules) => {
        if(valid) {
          // 判斷是否要同步投保人資料
          const { updDefInfo } = this.resultForm
          if(updDefInfo && updDefInfo.length > 0&&!this.isFina) {
            // if(this.resultForm.isUpdatePolicyData === 1) {
            this.$refs['policy-holder-form'].openConfirmDialog()
          }
          else {
            this.$emit('submit', this.resultForm)
          }
        }
        else {
          this.scrollToValidDom(rules)
        }
      })
    },
    // 記名司機同步
    handlerOpenDriver(data, list) {
      this.currentDriversData = data
    },
    handler() {
      return {
        validateForm: () => {
          if(this.isMotorTrade){
            delete this.subForm['insured-vehicle-form']
            if(this.isTPlate)
              delete this.subForm['drivers-base-info-form']
          }
          Object.keys(this.subForm).some(key => {
            this.subForm[key] = false
            this.$refs[key].submitForm(key)
          })
          if (Object.values(this.subForm).some(item => item === false)) {
            return false
          }
          return true
        },
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.policy-form {

}
.extra-box{
  ::v-deep .el-checkbox-group{
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>
